import React from 'react';
import './Badge.scss';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info' | 'navy' | 'gold';
  size?: 'small' | 'medium' | 'large';
  dot?: boolean;
  className?: string;
  onClick?: () => void;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'medium',
  dot = false,
  className = '',
  onClick
}) => {
  const badgeClasses = [
    'badge',
    `badge--${variant}`,
    `badge--${size}`,
    onClick && 'badge--clickable',
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses} onClick={onClick}>
      {dot && <span className="badge__dot" />}
      {children}
    </span>
  );
};

export default Badge;